import type { Letters } from '@/domain/scoring';
import { HiWord } from './HiWord';
import styles from './RoundHighlightCard.module.css';

interface Props {
  tag: string;
  word: string;
  who: string;
  icon: string;
  color: 'l1' | 'l2' | 'l3';
  letters: Letters;
  delay?: number;
}

export function RoundHighlightCard({ tag, word, who, icon, color, letters, delay }: Props) {
  return (
    <div
      className={`${styles.card} ${styles[color]}`}
      style={delay != null ? { animationDelay: `${delay}s` } : undefined}
    >
      <div className={styles.iconBox}>{icon}</div>
      <div className={styles.body}>
        <div className={styles.tag}>{tag}</div>
        <HiWord word={word} letters={letters} />
      </div>
      <span className={styles.who}>{who}</span>
    </div>
  );
}
